import { DropdownTrigger } from "../dropdown/Dropdown";
import CheckIcon from "../icons/CheckIcon";

interface IHandlingerDropdownTriggerProps {
  allSelected: boolean;
  totalCount: number;
  selectedIdsLength: number;
  type: "personer" | "firmaer" | "linjer" | "kurser" | string;
  badgeSolid?: boolean;
}
export default function HandlingerDropdownTrigger(
  props: IHandlingerDropdownTriggerProps,
) {
  const { allSelected, selectedIdsLength, totalCount, type, badgeSolid } =
    props;
  const anySelected = (allSelected && totalCount > 0) || selectedIdsLength > 0;

  if (anySelected) {
    return (
      <DropdownTrigger>
        <span
          className={`badge badge--fixed-size ms-n2${
            badgeSolid ? " badge--solid" : ""
          }`}
        >
          <span className="ms-n2">
            <CheckIcon />
          </span>
          <strong>{allSelected ? totalCount : selectedIdsLength}</strong>{" "}
          <span>{type} valgt</span>
        </span>
        <span className="fw-semibold">Handlinger</span>
      </DropdownTrigger>
    );
  } else {
    return (
      <DropdownTrigger disabled>
        <span className="badge badge--fixed-size bg-light text-secondary ms-n2">
          <span>Ingen {type} valgt</span>
        </span>
        <span className="fw-semibold">Handlinger</span>
      </DropdownTrigger>
    );
  }
}
